<template>
    <a href="#" :class="cssClassContainer" @click="expand" @mouseleave="collapse">
        {{ caption }}
        <div class="select-control-list" v-show="expanded">
            <a
                    class="select-control-item"
                    href="#"
                    v-for="(option, index) in options"
                    :key="index"
                    @click="selectOption(index)">
                {{ label ? option[label] : option }}
            </a>
        </div>
    </a>
</template>

<script>

export default {
  name: 'SelectControl',

  data: () => {
    return {
      selected: 0,
      expanded: false
    }
  },

  props: {
    label: {
      type: String
    },

    options: {
      type: Array,
      required: true
    },

    value: {

    }
  },

  computed: {
    caption: function () {
      if (this.options.length === 0) {
        return ''
      }
      return this.label ? this.options[this.selected].label : this.options[this.selected]
    },

    cssClassContainer: function () {
      return 'select-control ' +
        (this.expanded ? 'expanded' : '')
    }
  },

  methods: {
    collapse: function () {
      this.expanded = false
      return false
    },

    expand: function () {
      this.expanded = !this.expanded
      return false
    },

    selectOption: function (index) {
      this.$emit('input', this.options[index].value)
      this.selected = index
    }
  }
}
</script>

<style>
a.select-control {
    color: #fff;
    text-decoration: none;
    display: inline-block;
    position: relative;
    border-bottom: 2px dashed #fff;
}

a.select-control:hover {
    background-color: rgba(36, 130, 106, 1)
}

a.select-control.expanded {
    color: #d3e6e1;
}

a.select-control.expanded,
.select-control-list {
    background-color: rgba(36, 130, 106, 1);
}

.select-control-list {
    border: 1px solid #92c1b5;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, .25);
    display: block;
    position: absolute;
    width: max-content;
    z-index: 9999;
}

a.select-control-item {
    display: block;
    color: #fff;
    text-decoration: none;
    padding: .25rem .5rem;
}

a.select-control-item:hover {
    color: #24826a;
    background-color: white;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectControl.vue